import moment, { Moment } from 'moment';
import Vue from 'vue';
import {mapActions} from 'vuex';
import {AxiosResponse} from 'axios';
import StorageService from '../../lib/services/storageService';
import LifeSpaService from '../../lib/services/lifeSpaService';
import {ClubModuleConstant, ProfileModuleConstant, UrlModuleConstant, StorageConstant} from '../../lib/constants';
import BookingConfirmation from './booking-confirmation.html';
import LifeSpa from 'types/ls/lifespa';
import LtFramework from 'types/lt/ltFramework';

const storageService: LtFramework.IStorageService = new StorageService();
const lifeSpaService: LifeSpa.ILifeSpaService = new LifeSpaService();

interface IComponentData {
	slot: LifeSpa.ISlot;
	time: Moment;
	club: LtFramework.IClub;
	telephone: string;
}

export default Vue.component('lifeSpaBookingConfirmation', {
	template: BookingConfirmation,
	data(): IComponentData {
		return {
			slot: {} as LifeSpa.ISlot,
			time: {} as Moment,
			club: {} as LtFramework.IClub,
			telephone: '',
		};
	},
	computed: {
		dateDisplay: function() {
			if (this.time && typeof this.time.format === 'function') {
				return this.time.format('dddd, MMMM Do');
			}
		},
		timeStart: function() {
			if (this.time && typeof this.time.format === 'function') {
				let start: string = '';
				start += this.time.format('h:mm');
				return start;
			}
		},
		timeEnd: function() {
			if (this.time && typeof this.time.format === 'function') {
				let end: string = '';
				end  += moment(this.time).add(this.slot.duration, 'm').format('h:mm');
				return end;
			}
		},
		timeAMPM: function() {
			if (this.time && typeof this.time.format === 'function') {
				return moment(this.time).add(this.slot.duration, 'm').format('A');
			}
		},
		icsPath: function() {
			if (this.time && typeof this.time.format === 'function') {
				let path: string = '/bin/lt/calendar.ics';
				path += '?prodid=' + encodeURIComponent('-//Life Time LifeSpa//NONSGML Event Calendar//EN');
				path += '&dtstart=' + encodeURIComponent(this.club.timeZone) + ':' + this.time.format('YYYYMMDDTHHmm00');
				path += '&dtend=' + encodeURIComponent(this.club.timeZone) + ':' + moment(this.time).add(this.slot.duration, 'm').format('YYYYMMDDTHHmm00');
				path += '&summary=' + encodeURIComponent(this.slot.serviceName);
				path += '&location=LifeSpa%20' + encodeURIComponent(this.club.name);
				path += '&description=With%20' + encodeURIComponent(this.slot.name + '. Please arrive 5 minutes early. 24 hour notification is required for all cancellations.');
				return path;
			}
		},
		googlePath: function() {
			if (this.time && typeof this.time.format === 'function') {
				let path: string = 'https://calendar.google.com/calendar/r/eventedit';
				path += '?dates=' + this.time.format('YYYYMMDDTHHmm00/');
				path += moment(this.time).add(this.slot.duration, 'm').format('YYYYMMDDTHHmm00');
				path += '&ctz=' + encodeURIComponent(this.club.timeZone);
				path += '&text=' + encodeURIComponent(this.slot.serviceName);
				path += '&location=LifeSpa%20' + encodeURIComponent(this.club.name);
				path += '&details=With%20' + encodeURIComponent(this.slot.name + '. Please arrive 5 minutes early. 24 hour notification is required for all cancellations.');
				return path;
			}
		},
	},
	methods: {
		// store synchronization methods
		...mapActions(ProfileModuleConstant.name, {
			synchronizeProfileStore: ProfileModuleConstant.action.synchronize,
		}),
		...mapActions(ClubModuleConstant.name, {
			synchronizeClubStore: ClubModuleConstant.action.synchronize,
		}),
		hideModal() {
			// @ts-ignore
			$('#calendarModal').modal('hide');
		},
		getClubInfo(clubId: number) {
			return lifeSpaService.getClubInfo(clubId);
		},
	},
	created(): void {
		// @ts-ignore
		Promise.all([this.synchronizeProfileStore(), this.synchronizeClubStore()]).then(() => {
			this.club = window.LtFramework.getStore('ClubStore').getInitialData();
			const slot: LifeSpa.ISlot = storageService.get<LifeSpa.ISlot>(StorageConstant.lifespaSlot) as LifeSpa.ISlot;
			if (slot) {
				this.slot = slot;
				this.time = moment(this.slot.fulldatetime, 'DD-MMM-YY h:mm A');
			}
			this.getClubInfo(this.club.id).then((response: AxiosResponse<LifeSpa.IClubInfo>) => {
				this.telephone = response.data.data.data.location.settings.phone;
			});
		});
	},
});
